import swipevideo from './swipevideo';

window.swipevideo = swipevideo;



// WEBPACK FOOTER //
// ./src/browser.js